module.exports = __webpack_public_path__ + "static/media/reminders.15e51e3f.png";